import React from 'react';

import Advantage from './Advantage';
import ChineseAbility from './ChineseAbility';
import Team from './Team';
import StudyInWukong from './StudyInWukong';
import CourseFeatures from './CourseFeatures';
import CourseInteract from './CourseInteract';
import StudyArtifact from './StudyArtifact';
import TeachingForm from './TeachingForm';
import styles from './style.module.scss';

const Chinese = () => {
  return (
    <div className={styles.container}>
      {/* 悟空核心优势 */}
      <Advantage />

      {/* 培养中文能力 */}
      <ChineseAbility />

      {/* 教室团队 */}
      <Team />

      {/* 在悟空学习 */}
      <StudyInWukong />

      {/* 课堂特色 */}
      <CourseFeatures />

      {/* 互动课堂 */}
      <CourseInteract />

      {/* 学习神器 */}
      <StudyArtifact />

      {/* 授课形式 */}
      <TeachingForm />
    </div>
  );
};

export default Chinese;
